<template>
	<footer>
		<hr>&copy; <a href="https://jacknichao.github.io">Chao Ni</a> 2024 | <a
			href="https://scholar.google.com.hk/citations?user=ZTVm1RoAAAAJ&hl=zh-CN">Google Scholar</a> | <a
			href="https://github.com/jacknichao">GitHub</a>
			 <!-- | <a href="https://www.ccf.org.cn/c/2019-07-31/667605.shtml">CCF Rankings</a> -->
	</footer>
</template>

<style lang="">
	
</style>